import React from 'react';

export default function MicrophoneIcon(props) {
    return (
        <svg width='28' height='28' viewBox='0 0 28 28' {...props}>
            <path
                fill='#1D1D1B'
                fillRule='evenodd'
                d='M19.7 15.06l.001-.01c0 1-.237 1.935-.69 2.74a4.95 4.95 0 0 1-1.893 1.893c-.805.453-1.739.69-2.74.69-1 0-1.934-.237-2.738-.69a4.95 4.95 0 0 1-1.894-1.894 5.507 5.507 0 0 1-.687-2.55l1.38-.001.003.097c.039.656.211 1.258.504 1.778a3.572 3.572 0 0 0 1.37 1.37c.594.334 1.295.512 2.063.512.767 0 1.468-.178 2.063-.513a3.572 3.572 0 0 0 1.369-1.369 4.12 4.12 0 0 0 .51-1.874l1.376-.001.004-.178zm-5.319-6.825a2.567 2.567 0 0 1 2.568 2.568v4.258a2.567 2.567 0 0 1-5.135 0v-4.258a2.567 2.567 0 0 1 2.567-2.568z'
            />
        </svg>
    );
}
